// 自定义请求性能数据收集标记前缀
export const requestPerformancePrefix = {
  ajax: {
    performanceStartPrefix: 'mark_xhr_start_',
    performanceEndPrefix: 'mark_xhr_end_',
    measurePerformancePrefix: 'measure_xhr_',
    errorName: 'XHRError',
    errorMessage: 'XMLHttpRequest Error',
  },
  fetch: {
    performanceStartPrefix: 'mark_fetch_start_',
    performanceEndPrefix: 'mark_fetch_end_',
    measurePerformancePrefix: 'measure_fetch_',
    errorName: 'FetchError',
    errorMessage: 'Fetch Error',
  },
};

// 酷家乐调用链 http Header 透传头
export const qunheHeaders = {
  TraceId: 'x-qh-hunter-trace-id',
  ParentSpanId: 'x-qh-hunter-parent-span-id',
  Sampled: 'x-qh-hunter-sampled',
  Enabled: 'x-qh-hunter-enabled',
  UriPattern: 'x-qh-hunter-uri-pattern',
  UserId: 'x-qh-hunter-user-id',
  QHID: 'x-qh-id',
};

// Coohom 调用链 http Header 透传头
export const coohomHeaders = {
  TraceId: 'X-B3-TraceId',
  SpanId: 'X-B3-SpanId',
  ParentSpanId: 'X-B3-ParentSpanId',
  Sampled: 'X-B3-Sampled',
  Flags: 'X-B3-Flags',
};

export enum DefTypes {
  NUMBER = 'Number',
  STRING = 'String',
  OBJECT = 'Object',
  ARRAY = 'Array',
  ERROR = 'Error',
  DATE = 'Date',
  EXCEPTION = 'Exception',
  FUNC = 'Function',
  UNDEFINED = 'undefined',
  INVALID_ERROR = 'Script error.',
  REQUEST = 'Request',
}

// 不用数据收集的域名
export const blackList = [
  'actionstat.qunhequnhe.com',
  'actionstat.kujiale.com',
  'mixpanel.com',
  'segment.io',
];

// userId 空值集
export const EMPTY_USERID = ['null', 'undefined'];
